module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 5.27c0bd40.png";